<template>
    <div id="for-personal-page">
        <CoinsBanner :banner="'personal-1.png'" :isBusiness="null">
            <template v-slot:title>Mejora tu vida y la de tu familia. Que nadie se quede atrás.</template>
        </CoinsBanner>
        <FundDestinations :needsPadding="true"/>
        <LoanDetail 
            :isBusiness="false" :isPersonal="true"/>
        <ExpressSimulator />
        <Benefits :img="'https://cdn.redgirasol.com/nuevo_portal/fotografias/foto-personal-business.png'"/>
        <OwnSuccessStories :projects="successList" :isPersonal="true">
            <template v-slot:title>
                Descubre qué proyectos hemos <span class="bold">financiado.</span>
            </template>
        </OwnSuccessStories>
        <HowItWorks/>
        <Requirements />
        <Teams :logo="'prestamo-personal-f.png'" :needsForm="true">
            <template v-slot:title>¿Promueves <span class="bold">créditos personales</span>?</template>
            <template v-slot:text>Formemos una alianza para facilitar <br> la inclusión financiera en México.</template>
        </Teams>
    </div>
</template>

<script>
import sal from 'sal.js';
import CoinsBanner from '@components/landing-components/for-business-components/CoinsBanner.vue';
import FundDestinations from '@components/landing-components/for-personal-components/FundDestinations.vue';
import LoanDetail from '@components/landing-components/for-business-components/LoanDetail.vue';
import Benefits from '@components/landing-components/for-business-components/Benefits.vue';
import OwnSuccessStories from '@components/landing-components/for-business-components/OwnSuccessStories.vue';
import HowItWorks from '@components/landing-components/for-personal-components/HowItWorks.vue';
import Requirements from '../../components/landing-components/for-personal-components/Requirements.vue';
import Teams from '../../components/landing-components/for-business-components/Teams.vue';
import ExpressSimulator from '../../components/landing-components/loan-simulator/ExpressSimulator.vue';
export default {
    name: "ForPersonalPage",
    components: {
        CoinsBanner,
        FundDestinations,
        LoanDetail,
        Benefits,
        OwnSuccessStories,
        HowItWorks,
        Requirements,
        Teams,
        ExpressSimulator
    },
    mounted() {
        sal();
    },
    data() {
        return {
            successList: [
                {
                alias: "Sergio",
                photo: "sergio.jpg",
                item_list: [
                    { title: "Frente:", value: "Vivienda" },
                    { title: "Línea de acción:", value: "Remodelación" },
                    { title: "Monto:", value: "$100,000.00" },
                    { title: "Estado:", value: "Yacatán" },
                    { title: "Inversionistas:", value: "1191" },
                ]
                },
                {
                alias: "Alfredo",
                photo: "alfredo.jpeg",
                item_list: [
                    { title: "Frente:", value: "Micronegocio" },
                    { title: "Línea de acción:", value: "Abastecimiento" },
                    { title: "Monto:", value: "$180,000.00" },
                    { title: "Estado:", value: "Querétaro" },
                    { title: "Inversionistas:", value: "1191" },
                ]
                },
                {
                alias: "Irving",
                photo: "irving.jpg",
                item_list: [
                    { title: "Frente:", value: "Micronegocio" },
                    { title: "Línea de acción:", value: "Equipamiento" },
                    { title: "Monto:", value: "$100,000.00" },
                    { title: "Estado:", value: "Hidalgo" },
                    { title: "Inversionistas:", value: "1191" },
                ]
                },
            ]
        }
    },
    methods: {

    }
}
</script>